import { Progress } from "antd";
import React from "react";
import useOptimizedMicVolume from "../hooks/useOptimizedMicVolume";
import useRecorderContext from "../context/useRecorderContext";

const VolumeProgress = () => {
  const { microphoneStream } = useRecorderContext();
  const micVolume = useOptimizedMicVolume(microphoneStream);

  // Don't render if no microphone stream
  if (!microphoneStream) {
    return null;
  }

  return (
    <Progress
      percent={micVolume}
      status="active"
      showInfo={false}
      style={{ marginBlock: 8 }}
      strokeColor={{
        from: "#108ee9",
        to: "#87d068",
      }}
    />
  );
};

export default VolumeProgress;
